import { render, staticRenderFns } from "./OverlayFrame.vue?vue&type=template&id=a4836e5a&scoped=true&"
import script from "./OverlayFrame.vue?vue&type=script&lang=js&"
export * from "./OverlayFrame.vue?vue&type=script&lang=js&"
import style0 from "./OverlayFrame.vue?vue&type=style&index=0&id=a4836e5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4836e5a",
  null
  
)

export default component.exports